export default {
  registers: [],
  cashDrops: [],
  cashFloats: [],
  prepareUserList: [],
  loading: false,
  total: 0,
  FilteredCount: 0
}
